var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.092 4.668l.114.108.11.116a3.018 3.018 0 010 4.03l-.11.115L11.252 21.09l-.605.62-7.626 3.27 2.974-6.946.343-.637 12.609-12.62c1.113-1.113 2.983-1.15 4.145-.108zM8.92 21.376l-2.296-2.299L4.9 23.1l4.02-1.724zM16.3 8.824l-9.054 9.063 2.863 2.866 9.053-9.063-2.863-2.866zm1.91-1.914l-1.121 1.125 2.823 2.835 1.161-1.094L18.21 6.91zm2.867-2.01c-.477 0-.953.158-1.323.474l-.127.12-.68.595 2.836 2.948.726-.697a2.03 2.03 0 000-2.866c-.35-.351-.82-.54-1.3-.57l-.132-.004z",
    fill: "currentColor"
  })));
}
export default SvgEdit;